import { takeLatest } from 'redux-saga/effects';

import fetchIssueTypesData from './IssueTypes/IssueTypes';
import fetchSelectedIssueDataSaga from './SelectedIssue/SelectedIssue';
import fetchSettingsDataSaga from './Settings/Settings';

function* RootSaga(){
    yield takeLatest('FETCH_ISSUE_TYPES_DATA', fetchIssueTypesData);
    yield takeLatest('FETCH_SELECTED_ISSUE_DATA', fetchSelectedIssueDataSaga);
    yield takeLatest('FETCH_SETTINGS_DATA', fetchSettingsDataSaga);
}

export default RootSaga;